import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (qualifierId: string) =>
      await request(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers/${qualifierId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
